import angular from 'angular';
import loanSubmissionEmailContent from './loanSubmissionEmailContent';
import './style.scss';

export default angular
  .module('components.loanSubmissionEmailContent', [])
  .component('loanSubmissionEmailContent', loanSubmissionEmailContent).name;
